(function () {
  'use strict';

  /**
   * Deferred load-more for Click pagination mode.
   *
   * Theme setting "Click" makes Ajaxinate use click handlers only — no scroll
   * listeners and no requests on page load. This script watches the load-more
   * button and programmatically clicks it when it nears the viewport, giving
   * infinite-scroll UX without eager Ajaxinate requests.
   *
   * Manual clicks are handled by Ajaxinate directly.
   */

  var SECTIONS = [
    {
      selector: '[data-section-type="collection"]',
      trigger: '.collection__infinite-trigger'
    },
    {
      selector: '[data-section-type="search"]',
      trigger: '.search__infinite-trigger'
    }
  ];

  var MAX_SETUP_ATTEMPTS = 60;
  var setupAttempts = 0;

  var observer = null;
  var observedLink = null;
  var mutationObservers = [];

  function getConfig() {
    return (window.theme && window.theme.felina) || {};
  }

  function getSectionInstances() {
    return (
      (window.Shopify &&
        window.Shopify.theme &&
        window.Shopify.theme.sections &&
        window.Shopify.theme.sections.instances) ||
      []
    );
  }

  function getAjaxinateInstance(section) {
    var instances = getSectionInstances();
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].container === section) {
        return instances[i].infiniteScroll || null;
      }
    }
    return null;
  }

  function usesDeferredClick(section) {
    return section && section.dataset.paginationType === 'click';
  }

  function isScrollRestoring() {
    return window.__collectionScrollRestoring === true;
  }

  function getLoadLink(trigger) {
    if (!trigger) return null;
    return trigger.querySelector('a[href]');
  }

  function isAjaxinateLoading(ajaxinate) {
    return !!(ajaxinate && ajaxinate.request && ajaxinate.request.readyState !== 4);
  }

  function disconnectIntersectionObserver() {
    if (!observer) return;
    observer.disconnect();
    observer = null;
    observedLink = null;
  }

  function programmaticClick(section, triggerEl) {
    if (isScrollRestoring()) return;

    var link = getLoadLink(triggerEl);
    if (!link) return;

    var ajaxinate = getAjaxinateInstance(section);
    if (!ajaxinate || ajaxinate.settings.method !== 'click') return;
    if (isAjaxinateLoading(ajaxinate) || ajaxinate.clickActive === false) return;

    link.click();
  }

  function observeTrigger(section, triggerEl) {
    if (!usesDeferredClick(section)) {
      disconnectIntersectionObserver();
      return;
    }

    var link = getLoadLink(triggerEl);
    if (!link) {
      disconnectIntersectionObserver();
      return;
    }

    if (!getAjaxinateInstance(section)) return;

    if (observedLink === link && observer) return;

    disconnectIntersectionObserver();

    var rootMargin = getConfig().infiniteScrollRootMargin || '400px 0px';

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || isScrollRestoring()) return;
          programmaticClick(section, triggerEl);
        });
      },
      {
        root: null,
        rootMargin: rootMargin,
        threshold: 0
      }
    );

    observer.observe(link);
    observedLink = link;
  }

  function watchTrigger(section, triggerEl) {
    if (triggerEl.dataset.felinaDeferredLoadWatch === 'true') return;
    triggerEl.dataset.felinaDeferredLoadWatch = 'true';

    var mo = new MutationObserver(function () {
      requestAnimationFrame(function () {
        observeTrigger(section, triggerEl);
      });
    });

    mo.observe(triggerEl, { childList: true, subtree: true });
    mutationObservers.push(mo);
  }

  function setupSection(config) {
    var section = document.querySelector(config.selector);
    if (!section || !usesDeferredClick(section)) return false;

    var trigger = section.querySelector(config.trigger);
    var link = getLoadLink(trigger);
    var ajaxinate = getAjaxinateInstance(section);

    if (!trigger || !link || !ajaxinate) return false;

    watchTrigger(section, trigger);
    observeTrigger(section, trigger);
    return true;
  }

  function setup() {
    var allReady = true;

    SECTIONS.forEach(function (config) {
      var section = document.querySelector(config.selector);
      if (!section || !usesDeferredClick(section)) return;

      if (!setupSection(config)) {
        allReady = false;
      }
    });

    if (!allReady && setupAttempts < MAX_SETUP_ATTEMPTS) {
      setupAttempts += 1;
      requestAnimationFrame(setup);
    }
  }

  function resetMutationObservers() {
    mutationObservers.forEach(function (mo) {
      mo.disconnect();
    });
    mutationObservers = [];
  }

  function resetAndSetup() {
    setupAttempts = 0;
    disconnectIntersectionObserver();
    resetMutationObservers();
    requestAnimationFrame(setup);
  }

  function init() {
    // Stop load-more links from navigating; Ajaxinate handles the click.
    document.addEventListener(
      'click',
      function (e) {
        var link = e.target.closest(
          '.collection__infinite-trigger a[href], .search__infinite-trigger a[href]'
        );
        if (!link) return;
        e.preventDefault();
      },
      true
    );

    resetAndSetup();

    document.addEventListener('collection:updated', resetAndSetup);
    window.addEventListener('collectionScrollRestored', resetAndSetup);
    document.addEventListener('shopify:section:load', resetAndSetup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
